import React, { Component } from 'react';
import { Form } from 'reactstrap';
import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from "jodit-react";
import Swal from 'sweetalert2';
import mail from "../../../services/mail";
import Loader from '../../../container/Loader';

class FormMail extends Component {

    constructor(props) {
      super(props)
      this.state = { 
        loading: false,
        errors: {},
        id: 0,
        tags: [],
        descricao: '', 
        assunto: '', 
        assinatura: '', 
        destinatarios: '', 
        destinatarios_copia: '',
        mensagem: '',
      }
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
  }

  updateContent = (value) => {
    this.setState({mensagem:value})
  }

  jodit;
  setRef = jodit => this.jodit = jodit;
  
  config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    minHeight: '500',
	}

  handleChange(e){
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  tagsMail(){

    this.setState({loading: true});
    mail.get('/vendaonline/padrao-email/tags')
    .then(response => {
      this.setState({ tags: response.data, loading: false});   
    })
    .catch(function (error) {
      console.log(error);
    })

  }

  componentDidMount() {

    this.tagsMail();

    if (this.props.edit) {
      this.setState({loading: true});
      const id  = this.props.data.id;
      const Authorization = 'dRc9HOHgfpJVBEvm5TpwJSqpJ'

    mail.post('/vendaonline/padrao-email/show', {id: id }, {
      headers: { Authorization },
    })
    .then(response => {
      const { id, descricao, assunto, mensagem, assinatura, destinatarios, destinatarios_copia } = response.data;
      this.setState({ id, descricao, assunto, mensagem, assinatura, destinatarios, destinatarios_copia, loading: false});   
    })
    .catch(function (error) {
      console.log(error);
    })   
  }
}

  handleSubmit(e) {
    e.preventDefault();
      const Authorization = 'dRc9HOHgfpJVBEvm5TpwJSqpJ';
      const url = this.props.edit ? 'update' : 'create';
    mail.post(`/vendaonline/padrao-email/${url}`, 
    {
      id: this.state.id, 
      descricao: this.state.descricao, 
      assunto: this.state.assunto, 
      mensagem: this.state.mensagem, 
      assinatura: this.state.assinatura, 
      destinatarios: this.state.destinatarios, 
      destinatarios_copia: this.state.destinatarios_copia
    },
    { headers: { Authorization }} )
    .then((response) => {
      Swal.fire({
        title: response.data ? 'Email cadastrado com sucesso' : 'Ocorreu um erro ao salvar, tente novamente.',
        icon: response.data ? 'success': 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      })      
    });    
  }

  render() {
    let closeBtn = '';
    const isLoggedIn = this.state.loading;
    closeBtn = <button type="button" className="btn btn-danger" onClick={this.props.toggle} data-dismiss="modal">Fechar</button>  
    const data = this.state.tags.map(tag => {
      return (<span className="badge badge-light" style={{marginRight: '10px'}}> {tag.descricao} </span>)
    })
    return (
      <Form style={{ marginBottom: isLoggedIn ? '100px' : ''}} onSubmit={this.handleSubmit}>
        {isLoggedIn ? <Loader /> : 
        <div className="tab-pane fade pt-3 active show" id="cadastro" role="tabpanel" aria-labelledby="cadastro">
          <div className="cadastro-usuario-wrapper">
              <div className="dados-wrapper" >
                <div className="row">
                <div className="col">
                {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="1" className="labelB">Empreendimento <span style={{ color: 'red' }}>*</span></label>
                      <input type="file" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control-file"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Módulo Sistema <span style={{ color: 'red' }}>*</span></label>
                      <input type="file" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control-file"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Categoria Email <span style={{ color: 'red' }}>*</span></label>
                      <input type="file" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control-file"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Remetente <span style={{ color: 'red' }}>*</span></label>
                      <input type="file" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control-file"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="destinatarios" className="labelB">Descrição <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="descricao" defaultValue={this.state.descricao === null ? "" : this.state.descricao }
                        className="form-control"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.destinatarios}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="destinatarios" className="labelB">Destinatarios <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="destinatarios" defaultValue={this.state.destinatarios === null ? "" : this.state.destinatarios }
                        className="form-control"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.destinatarios}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="destinatarios_copia" className="labelB">Destinatarios Cópia </label>
                      <input type="text" name="destinatarios_copia" defaultValue={this.state.destinatarios_copia === null ? "" : this.state.destinatarios_copia }
                        className="form-control"
                        onChange={this.handleChange.bind(this)}
                      />
                      <small className="form-text text-danger">{this.state.errors.destinatarios_copia}</small>
                    </div>
                  </div>
                  {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Campanha</label>
                      <select className="form-control" onChange={this.handleChange.bind(this)}>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  {/* <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="nome" className="labelB">Axexos <span style={{ color: 'red' }}>*</span></label>
                      <input type="file" name="nome" defaultValue={this.state.nome === null ? "" : this.state.nome}
                        className="form-control-file"
                        placeholder="Nome"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.nome}</small>
                    </div>
                  </div> */}
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="assinatura" className="labelB">Assinatura <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="assinatura" defaultValue={this.state.assinatura === null ? "" : this.state.assinatura }
                        className="form-control"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.assinatura}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="assinatura" className="labelB">Tags</label>
                      <br />
                      {data}
                    </div>
                  </div>
                  </div>
                  <div className="col">
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="assunto" className="labelB">Assunto <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" name="assunto" defaultValue={this.state.assunto === null ? "" : this.state.assunto }
                        className="form-control"
                        onChange={this.handleChange.bind(this)} required
                      />
                      <small className="form-text text-danger">{this.state.errors.assunto}</small>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="mensagem" className="labelB">Mensagem</label>
                      <JoditEditor
                        editorRef={this.setRef}
                        value={this.state.mensagem}
                        config={this.config}
                        onChange={this.updateContent}
                    />
                      <small className="form-text text-danger">{this.state.errors.mensagem}</small>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          <div className="modal-footer" style={{marginTop: '15px'}}>
            {closeBtn}
            <button type="submit" className="btn btn-primary" style={{marginRight:'-15px'}}><i className="fa fa-floppy-o" aria-hidden="true"></i> Salvar</button>
          </div>
        </div>
        }
      </Form>
    );
  }
}

export default FormMail